import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import {
  activityFrequencySchema,
  recurringOptionSchema,
} from "./schedulingModels";
import type { ISchedulingFields } from "./Scheduling";

export const useSchedulingReset = () => {
  const { unregister, watch } = useFormContext<ISchedulingFields>();

  const frequency = watch("frequency");
  const recurrence = watch("recurrence");

  const isRecurring = frequency === activityFrequencySchema.enum.recurring;
  const isRecurringOnWeekdays =
    recurrence === recurringOptionSchema.enum.onSelectedWeekdays;
  const isCustomRecurring = recurrence === recurringOptionSchema.enum.custom;

  useEffect(() => {
    if (!isRecurringOnWeekdays) {
      unregister("weekdays");
    }
  }, [isRecurringOnWeekdays, unregister]);

  useEffect(() => {
    if (!isRecurring) {
      unregister("recurrence");
    }
  }, [isRecurring, unregister]);

  useEffect(() => {
    if (!isCustomRecurring) {
      unregister("customRecurrenceInterval");
      unregister("customRecurrenceIntervalUnit");
    }
  }, [isCustomRecurring, unregister]);

  return { isRecurring, isRecurringOnWeekdays, isCustomRecurring };
};
